///<reference path="../../../../typings/globals/angular/index.d.ts"/>
module Meevo.Components.Common {

    export interface IRatingRow {
        rating: number;
        ratingCount: number;
    }

    export interface IRatingsService {
        ratingsMapFn(ratings: IRatingRow[]): { rating: number; answers: number; };
    }

    export class RatingsService implements IRatingsService {
        static factory(): Function {
            const service = () => {
                return new RatingsService();
            };

            service.$inject = [];
            return service;
        }

        ratingsMapFn(ratings: IRatingRow[]): { rating: number; answers: number; } {
            let rating = 0,
                answers = 0;

            if (ratings.length) {
                ratings.forEach((item) => {
                    if (item.rating && item.rating != 0) {
                        rating += item.rating * item.ratingCount;
                        answers += item.ratingCount;
                    }
                });
                rating = rating / answers;

                // New rating calculation rounds down to the nearest 0.25 instead of 0.5
                rating = Math.floor(rating * 4) / 4;
                rating = isNaN(rating) ? 0 : rating;
            }
            return {rating, answers};
        }
    }

    angular.module('meevo')
        .factory('meevo.components.common.RatingsService', RatingsService.factory());
}